<template>
  <div class="absolute inset-0 pointer-events-none opacity-[0.04] grayscale select-none overflow-hidden">
    <!-- Calculator Doodle -->
    <svg class="absolute top-10 left-[5%] w-32 h-32 rotate-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
      <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
      <line x1="8" y1="6" x2="16" y2="6"></line>
      <line x1="16" y1="14" x2="16" y2="18"></line>
      <path d="M16 10h.01"></path>
      <path d="M12 10h.01"></path>
      <path d="M8 10h.01"></path>
      <path d="M12 14h.01"></path>
      <path d="M8 14h.01"></path>
      <path d="M12 18h.01"></path>
      <path d="M8 18h.01"></path>
    </svg>
    
    <!-- Paycheck Doodle -->
    <svg class="absolute top-[25%] right-[10%] w-48 h-48 -rotate-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7z"></path>
      <path d="M16 11h3"></path>
      <path d="M16 15h3"></path>
      <path d="M5 11h6"></path>
      <path d="M5 15h4"></path>
    </svg>

    <!-- Time/Clock Doodle -->
    <svg class="absolute top-[50%] left-[2%] h-32 w-32 rotate-45" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>

    <!-- Chart Doodle -->
    <svg class="absolute bottom-[15%] right-[5%] w-40 h-40 -rotate-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"></line>
      <line x1="12" y1="20" x2="12" y2="4"></line>
      <line x1="6" y1="20" x2="6" y2="14"></line>
    </svg>

    <!-- Piggy Bank Doodle -->
    <svg class="absolute top-[35%] left-[15%] w-28 h-28 rotate-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2 .5-.5.7-1 .5-2.5z"></path>
      <path d="M7 11h.01"></path>
      <path d="M11 5v2"></path>
    </svg>

    <!-- Bank Card Doodle -->
    <svg class="absolute top-[5%] right-[25%] w-32 h-32 -rotate-45" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
      <rect x="2" y="5" width="20" height="14" rx="2"></rect>
      <line x1="2" y1="10" x2="22" y2="10"></line>
    </svg>

    <!-- Personnel Doodle -->
    <svg class="absolute bottom-[40%] left-[20%] w-36 h-36 -rotate-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>

    <!-- Shield/Compliance Doodle -->
    <svg class="absolute bottom-[10%] left-[40%] h-32 w-32 rotate-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>

    <!-- Coins Doodle -->
    <svg class="absolute top-[60%] right-[20%] h-32 w-32 rotate-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="8" cy="8" r="6"></circle>
      <path d="M18.09 10.37A6 6 0 1 1 10.34 18"></path>
      <path d="M7 6h1v4"></path>
      <path d="M11 11h1v4"></path>
    </svg>

    <!-- File Doodle -->
    <svg class="absolute top-[15%] left-[45%] h-24 w-24 -rotate-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="16" y1="13" x2="8" y2="13"></line>
      <line x1="16" y1="17" x2="8" y2="17"></line>
      <polyline points="10 9 9 9 8 9"></polyline>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'DoodleBackground'
}
</script>
